module.exports = __webpack_public_path__ + "static/img/testimony (24).56e8047b.jpg";